﻿<script>
    import { tick } from "svelte";
	import { nanoid } from "nanoid";

	import ToolTip from "./ToolTip.svelte"
	import { patternFilterFactory } from "../helpers/patternMatching"

	export let id = nanoid(6);
	export let label;
	export let sublabel = null;
	export let value;
	export let disabled = null;
	export let required = null;
	export let minlength = null;
	export let maxlength = null;
	export let placeholder = null;
	export let exceptions = null;
	export let alphaOnly = false;
	export let numericOnly = false;
	export let dataValidator = null;
	export let errorMessageTarget = null;
	export let patternValidator = null;
	export let dataBouncerMessage = null;
	export let tooltipText = null;

	let baseMatchRegEx = new RegExp("^[a-zA-Z0-9]+$");
	let patternFilter = patternFilterFactory(numericOnly, alphaOnly, exceptions);
	$: {
		if (alphaOnly) {
			baseMatchRegEx = new RegExp("^[a-zA-Z]+$");
		} else if (numericOnly) {
			baseMatchRegEx = new RegExp("^[0-9]+$");
		}
		patternFilter = patternFilterFactory(numericOnly, alphaOnly, exceptions);
	}
	
	const handleKeyDown = (e) => {
		if (
			e.key == "Backspace" ||
			e.key == "Delete" ||
			e.key == "ArrowLeft" ||
			e.key == "ArrowRight" ||
			e.key === "Enter"
		) {
			return true;
		}
	};

	const handleKeyPress = (e) => {
		//check for illegal leading characters
		if (!e.target.value && !e.key.match(baseMatchRegEx)) {
			e.preventDefault();
			return false;
		}

		if (e.metaKey || e.altKey || e.ctrlKey || e.key === "Enter") {
			return true;
		}

		if (e.key.match(baseMatchRegEx)) {
			return true;
		}

		if (exceptions && exceptions.indexOf(e.key) >= 0) {
			return true;
		}

		e.preventDefault();
		return false;
	};

	const handlePaste = async (e) => {
		let selectionStart = e.target.selectionStart;
		let selectionEnd = e.target.selectionEnd;
		let pasted = patternFilter(e.clipboardData.getData('text'));

		if (value) {
			value = value.substring(0, selectionStart) +
			    pasted +
				value.substring(selectionEnd);
		} else {
			value = pasted;
		}

		await tick();

		e.target.selectionStart = selectionStart + pasted.length
		e.target.selectionEnd = e.target.selectionStart

		e.preventDefault();
		return false;
	};

</script>

{#if label}
	<label for={id}>
		{label} <ToolTip {tooltipText} />

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}

	</label>
{/if}
<input
	{id}
	{required}
	{disabled}
	{minlength}
	{maxlength}
	{placeholder}
	type="text"
	bind:value
	on:change
	class="form-control"
	on:keydown={handleKeyDown}
	on:keypress={handleKeyPress}
	on:paste={handlePaste}
	data-validator="{dataValidator}"
	data-bouncer-target="{errorMessageTarget}"
	pattern="{patternValidator}"
	data-bouncer-message="{dataBouncerMessage}"
/>

<style>
</style>
